// extracted by mini-css-extract-plugin
export default {"card":"AdvCard_card__YnL6J","icon":"AdvCard_icon__w2ln9","txt":"AdvCard_txt__5JCV1"};